import React, { useEffect } from 'react';
import styled from 'styled-components';
import NormalInput from '../common/input/NormalInput';
import CurrencyInput from 'react-currency-input-field';
import { useState } from 'react';
import SpanPckgNavPrice from '../common/price/SpanPckgNavPrice';
import NormalBtn from '../common/button/NormalBtn';
import SubmitBtn from '../common/button/SubmitBtn';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { esApplyProdDao, setEsApplyProdEditAction, setEsApplyInfoAction, reqEsApplyAction, EsApplyInfoDao, setEsApplyDelAllAction } from '../../modules/es/esApplyModule';
import loadingReducer from '../../modules/common/loadingModule';
import * as CONSTANTS from '../../lib/util/Constants';

/**
 * 견적 작성하기 > 하단 견적 추가 Layer 안에 있는 패키지 명 등의 정보 입력 컴포넌트
 */
const EsApplyPckgNavInputBoxBlock = styled.div`
    position: relative;
    margin-left: -40px;
    max-width: 1176px;
    margin: 0 auto;

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const EsApplyPckgNavInputBoxGridItemBlock = styled.div`
    position: relative;
    padding-left: 40px;
    float: left;
    width: 50%;
`;

const EsApplyPckgNavInputBoxGridItemBlock2 = styled.div`
    position: relative;
    padding-left: 40px;
    float: left;
    width: 50%;
`;

const EsApplyPckgNavInputBoxClearFixBlock = styled.div`
    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const EsApplyPckgNavInputBox = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [focused, setFocused] = useState(false);
    const [totalCnt, setTotalCnt] = useState(0);
    const [pckgNm, setPckgNm] = useState('')
    const [price, setPrice] = useState(0);

    const { esApplyTotalCnt, esApplyTotalPrice, accessToken, esApplyInfo, esApplyProdList } = useSelector(
        ({ esApplyReducer, userReducer, loadingReducer }) => ({
            esApplyTotalCnt: esApplyReducer.esApplyTotalCnt,
            esApplyTotalPrice: esApplyReducer.esApplyTotalPrice,
            accessToken: userReducer.accessToken,
            esApplyInfo: esApplyReducer.esApplyInfo,
            esApplyProdList: esApplyReducer.esApplyProdList
        })
    );

    useEffect(() => {
        // console.log("esApplyTotalCnt +++++++++++++ : " + JSON.stringify(esApplyTotalCnt));
        setTotalCnt(esApplyTotalCnt);

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = EsApplyInfoDao();
        }
        applyinfo.es_prod_cnt = esApplyTotalCnt;
        applyinfo.es_prod_total_price = esApplyTotalPrice;
        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]

        return function cleanup() {
            setTotalCnt(0);
            setPckgNm('');
        }

    }, [esApplyTotalCnt, esApplyInfo, esApplyProdList])

    // 패키지 금액 포커서 확인
    const handleChangeCurInputFocus = () => {
        // console.log("handleChangeCurInputFocus")
        setFocused(true);
    }

    const handleChangeCurInputBlur = () => {
        // console.log("handleChangeCurInputBlur")
        setFocused(false);
    }

    // 견적 요청
    const handlerClickSubmit = () => {

        if (totalCnt < CONSTANTS.MIN_ITEM) {
            alert(`상품의 갯수가 ${CONSTANTS.MIN_ITEM}개 이상 이어야 견적 요청이 가능합니다.`);
            return;
        }

        // 패키지 이름 확인
        if (pckgNm === null || pckgNm.length === 0) {
            alert("패키지명을 입력해 주세요.");
            return;
        }

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            alert("배송 주소를 확인 해 주세요.");
            return;
        }

        if (applyinfo.addr1 === null || applyinfo.addr2 === null) {
            alert("배송 주소 및 상세 주소를 확인 해 주세요.");
            return;
        }

        applyinfo.pckg_nm = pckgNm;
        applyinfo.rqst_price = price;
        applyinfo.rqst_status = "050102"; // 요청

        dispatch(setEsApplyInfoAction(applyinfo));
        //[SAVE REDUX END]

        // 로그인 되어 있지 않으면 로그인 화면으로 이동
        if (accessToken === null) {
            return history.push('/login');
        } else {
            let applyprod = esApplyProdList;

            // 스토어의 모든 정보 삭제
            dispatch(setEsApplyDelAllAction());

            // console.log("apply prod -----> " + JSON.stringify(applyprod))

            // 서버로 견적서 요청
            dispatch(reqEsApplyAction(accessToken, applyinfo, applyprod));

            return history.push('/es');
        }
    }

    // 임시 저장
    const handlerClickSave = () => {

        // 패키지 이름 확인
        if (pckgNm === null || pckgNm.length === 0) {
            alert("패키지명을 입력해 주세요.");
            return;
        }

        // [SAVE REDUX START]
        let applyinfo = esApplyInfo;
        if (applyinfo === null) {
            applyinfo = esApplyProdDao();
        }
        applyinfo.pckg_nm = pckgNm;
        applyinfo.rqst_price = price;
        applyinfo.rqst_status = "050101"; // 임시 저장

        dispatch(setEsApplyInfoAction(applyinfo));
        // [SAVE REDUX END]

        // 로그인 되어 있지 않으면 로그인 화면으로 이동
        if (accessToken === null) {
            return history.push('/login');
            // return <Redirect to="/login" />
        } else {
            // 임시 저장 처리
            dispatch(reqEsApplyAction(accessToken, applyinfo, esApplyProdList));
            return history.push('/es');
        }
    }

    const handleChangePackage = (e) => {
        setPckgNm(e.target.value);
    }

    const handleChangePrice = (value, name) => {
        // console.log("value : " + value + " , name : " + name);
        setPrice(value);
    }

    return (
        <EsApplyPckgNavInputBoxBlock>
            <EsApplyPckgNavInputBoxGridItemBlock>
                <NormalInput type='text'
                    maxLength='20'
                    placeholder='패키지명을 입력해 주세요'
                    marginBottom='20px'
                    onChange={handleChangePackage} />
                <EsApplyPckgNavInputBoxClearFixBlock>
                    <span className="f-left">희망 견적 금액</span>
                    <div className="item_input-box f-right">
                        <CurrencyInput
                            id="input-example"
                            name="input-name"
                            placeholder="0"
                            defaultValue={0}
                            allowDecimals={false}
                            onChange={handleChangePrice}
                            onFocus={handleChangeCurInputFocus}
                            onBlur={handleChangeCurInputBlur}
                            maxLength="14"
                            style={{
                                height: "40px",
                                border: focused ? "1px solid #ffc742" : "1px solid #ccc",
                                outline: "0",
                                borderRadius: "4px",
                                paddingRight: "32px",
                                width: "372px",
                                textAlign: 'right',
                                fontSize: '14px'
                            }}
                        />
                        <span style={{ position: 'absolute', top: '10px', right: '16px', fontSize: '14px' }}>원</span>
                    </div>
                </EsApplyPckgNavInputBoxClearFixBlock>
            </EsApplyPckgNavInputBoxGridItemBlock>
            <EsApplyPckgNavInputBoxGridItemBlock2>
                <EsApplyPckgNavInputBoxClearFixBlock>
                    <span className="f-left">총 상품 금액 ( 수량 {totalCnt}개 )</span>
                    <SpanPckgNavPrice value={esApplyTotalPrice} />
                </EsApplyPckgNavInputBoxClearFixBlock>

                <div style={{ float: "left", width: "33%" }}>
                    <NormalBtn text='임시저장' minWidth="176px" onClick={handlerClickSave} />
                </div>
                <div style={{ float: "right", width: "66%" }}>
                    <SubmitBtn text="견적요청하기"
                        width="100%"
                        textColor={totalCnt > 1 ? '#fff' : 'bbb'}
                        bgColor={totalCnt > 1 ? '#ffc742' : '#e0e0e0'}
                        onClick={handlerClickSubmit} />
                </div>
            </EsApplyPckgNavInputBoxGridItemBlock2>
        </EsApplyPckgNavInputBoxBlock>
    );
};

export default EsApplyPckgNavInputBox;
